import React, { useState } from "react";
import PropTypes from "prop-types";
import gql from "graphql-tag";
import { useMutation } from "@apollo/client";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";

import { GPS_LIVE_INTEGRATION_QUERY } from "./query";

const MUTATION = gql`
  mutation GpsLiveSetSafetyEventsEnabled(
    $input: GpsLive_SetSafetyEventsEnabled_Input!
  ) {
    integrations {
      gpsLive {
        setSafetyEventsEnabled(input: $input) {
          safetyEventsEnabled
          error {
            code
            message
          }
        }
      }
    }
  }
`;

const ChangeSafetyEventsDialog = ({ open, handleClose, checked }) => {
  const [errorMess, setErrorMess] = useState();
  const [loading, setLoading] = useState(false);
  const [change] = useMutation(MUTATION, {
    refetchQueries: () => [{ query: GPS_LIVE_INTEGRATION_QUERY }],
    awaitRefetchQueries: true,
  });

  const handleChange = () => {
    setLoading(true);
    setErrorMess(undefined);
    change({ variables: { input: { enabled: !checked } } })
      .then(({ data }) => {
        const error = data.integrations.gpsLive.setSafetyEventsEnabled.error;
        setLoading(false);
        if (error) {
          setErrorMess(`${error.message} (${error.code})`);
          return;
        }
        handleClose();
      })
      .catch((e) => {
        setLoading(false);
        setErrorMess(e.message);
      });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>GPS Live safety events</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure to {checked ? "disable" : "enable"} storing GPS Live
          events as safety events?
        </DialogContentText>
        {errorMess && <FormHelperText error={true}>{errorMess}</FormHelperText>}
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={handleClose} color="primary">
          Close
        </Button>
        <Button disabled={loading} onClick={handleChange} color="primary">
          {checked ? "Disable" : "Enable"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ChangeSafetyEventsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default ChangeSafetyEventsDialog;
